export default __webpack_public_path__ + "static/media/bandwidth-group-small.1427eac9.svg";